import { TextOperation, IRange } from '../constants'
import { createRange } from '../range'

const initialState = createRange(0, 0)

export function rangeReducer(state: IRange = initialState, operation: TextOperation) {
  switch (operation.type) {
    case 'insert':
      return insertOperation(state, operation.start, operation.text.length)
    case 'delete':
      return deleteOperation(state, operation.start, operation.length)
  }
  return state
}

export const insertOperation = (
  state: IRange,
  operationStart: number,
  operationLength: number,
): IRange => {
  const { start, length, end } = state
  if (operationStart <= start) {
    //  a b c d e f
    //+| |
    return createRange(start + operationLength, length)
  } else if (operationStart < end) {
    //  a b c d e f
    // | + |
    return createRange(start, length + operationLength)
  }
  //  a b c d e f
  // | |+
  return state
}

export const deleteOperation = (
  state: IRange,
  operationStart: number,
  operationLength: number,
): IRange => {
  const { start, length, end } = state
  const operationEnd = operationStart + operationLength

  if (operationStart <= start && operationEnd >= end) {
    //  a b c    a b c
    // |-|       -|-|-
    return createRange(operationStart, 0)
  }

  if (operationEnd <= start) {
    //  a b c d e f
    //  -| |
    return createRange(start - operationLength, length)
  }

  if (operationEnd <= end) {
    if (operationStart <= start) {
      //  a b c d e f
      //  -|-    |
      const length = end - operationEnd
      return createRange(operationStart, length)
    } else {
      //  a b c d e f
      // |  -  |
      return createRange(start, length - operationLength)
    }
  }

  if (operationStart < end) {
    //  a b c d e f
    // |    -|-
    return createRange(start, operationStart - start)
  }

  return state
}
